import React from "react";
import icons from "../../../assets/images/icons";
import styles from "./IdVerificationModal.module.scss";

function IdVerificationModal({onClose}){

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirmClick= () =>{
    onClose();
    window.handleShowUserAuthPopup();
    window.handleShowUserAuthPopupPendingContent();
    window.$('.user-auth-danal-button').off('click').click(window.handleSidebarDanalAuthAction);
  }

  const handleCancelClick = () =>{onClose()}

  return (
    <div className={styles.idVerificationModalOverlay} onClick={handleOverlayClick}>
      <div className={styles.idVerificationModalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.idVerificationModalHeader}>
            <img src={icons.idVerification.blue} alt="기본 이미지" width={80} height={80} />
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">
            <img src={icons.messager?.close} alt="" />
          </button>
        </div>
        <p className={styles.idVerificationModalText}>
          채팅서비스를 이용하시려면 먼저 <br />
          본인인증을 완료해주세요.
        </p>
        <div className={styles.idVerificationModalButtonWrapper}>
          <button
            type="button"
            className={`${styles.button} ${styles.chatButton}`}
            onClick={handleConfirmClick}
          >
            <span>인증하러 가기</span>
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.phoneButton}`}
            onClick={handleCancelClick}
          >
            <span>취소</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default IdVerificationModal
